export { default as Img200 } from './processed/200/santaanalane.jpg';
export { default as Img400 } from './processed/400/santaanalane.jpg';
export { default as Imgthumb } from './processed/thumb/santaanalane.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/santaanalane.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/santaanalane.jpg';
export const ImgData = { width: 600, height: 400, ratio: 0.6666666666666666, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      84,
      182,
      252
    ],
    "_population": 3,
    "_hsl": [
      0.5694444444444445,
      0.9655172413793105,
      0.6588235294117647
    ]
  },
  "LightVibrant": {
    "_rgb": [
      108,
      187,
      249
    ],
    "_population": 50,
    "_hsl": [
      0.5732860520094563,
      0.9215686274509807,
      0.7
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      91,
      52,
      34
    ],
    "_population": 535,
    "_hsl": [
      0.05263157894736842,
      0.456,
      0.2450980392156863
    ]
  },
  "Muted": {
    "_rgb": [
      160,
      112,
      98
    ],
    "_population": 72,
    "_hsl": [
      0.037634408602150525,
      0.246031746031746,
      0.5058823529411764
    ]
  },
  "LightMuted": {
    "_rgb": [
      164,
      162,
      203
    ],
    "_population": 33,
    "_hsl": [
      0.6747967479674798,
      0.28275862068965507,
      0.7156862745098038
    ]
  },
  "DarkMuted": {
    "_rgb": [
      45,
      47,
      88
    ],
    "_population": 431,
    "_hsl": [
      0.6589147286821705,
      0.32330827067669166,
      0.2607843137254902
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/santaanalane.js